import React, { useState } from 'react'
import { useField } from 'formik'
import { Icon } from '@iconify/react'
import clsx from 'clsx'

import styles from './RateField.module.css'

const RateField: React.FC = () => {
  const [hovered, setHovered] = useState(0)
  const [field, _meta, helper] = useField('rating')

  const handleClick = (index: number) => {
    const newRating = index + 1 === field.value ? 0 : index + 1
    helper.setValue(newRating)
  }

  const handleMouseEnter = (index: number) => {
    setHovered(index + 1)
  }

  const handleMouseLeave = () => {
    setHovered(0)
  }

  return (
    <div className={styles.ratingField}>
      {Array.from({ length: 5 }, (_, index) => (
        <div
          key={index}
          onClick={() => handleClick(index)}
          role="none"
          onMouseEnter={() => handleMouseEnter(index)}
          onMouseLeave={handleMouseLeave}
          className={styles.star}
        >
          <Icon
            icon="lucide:star"
            className={clsx(styles.starIcon, {
              [styles.starIconHovered]: index < (hovered || field.value)
            })}
          />
          {index === 0 && <div className={styles.ratingText}>Poor</div>}
          {index === 4 && <div className={styles.ratingText}>Excellent</div>}
        </div>
      ))}
    </div>
  )
}

export default RateField
